var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({class:['button',
                 {'button_full': _vm.full},
                 {'button_outline': _vm.outline},
                 {'button_outline-primary': _vm.outlinePrimary},
                 {'button_secondary': _vm.secondary},
                 {'is-disabled': _vm.disabled},
                 {'is-loading': _vm.loading}]},_vm.$listeners),[_c('span',{staticClass:"button__content"},[_c('span',{staticClass:"button__title"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }